import { createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from '../../apis'
import axios from 'axios';

import LocalStorage from "../../utils/storage";

const ROLE = LocalStorage.getItem('userRole');

export const completeCAD = createAsyncThunk('completeCAD', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/update-order`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});